import { render, staticRenderFns } from "./AddinForm.vue?vue&type=template&id=1241c365&lang=pug&"
import script from "./AddinForm.vue?vue&type=script&lang=ts&"
export * from "./AddinForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports